import { useCallback } from "react";

import {
	LOCAL_PAYMENT_AVAILABLE_LIMIT_DAYS_DEFAULT_VALUE,
	LOCAL_PAYMENT_CANCEL_FEE_TRANSFER_INFO_DEFAULT_VALUE,
} from "./default-value";
import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationDefaultIsLocalPaymentAvailable = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { isLocalPaymentAvailable } = viewModel;

	const isEdited = isLocalPaymentAvailable.isEdited;
	const hasError = Boolean(isLocalPaymentAvailable.error);

	const onSetIsLocalPaymentAvailable = useCallback(
		(input: boolean) => {
			onSetViewModel<
				| "isLocalPaymentAvailable"
				| "localPaymentCancelFeeTransferLimitDays"
				| "localPaymentCancelFeeTransferInfo"
			>([
				{
					key: "isLocalPaymentAvailable",
					value: {
						isEdited: true,
						value: input,
					},
				},
				{
					key: "localPaymentCancelFeeTransferLimitDays",
					value: input
						? viewModel.localPaymentCancelFeeTransferLimitDays
						: LOCAL_PAYMENT_AVAILABLE_LIMIT_DAYS_DEFAULT_VALUE,
				},
				{
					key: "localPaymentCancelFeeTransferInfo",
					value: input ? LOCAL_PAYMENT_CANCEL_FEE_TRANSFER_INFO_DEFAULT_VALUE : undefined,
				},
			]);
		},
		[onSetViewModel, viewModel.localPaymentCancelFeeTransferLimitDays],
	);

	return {
		isEdited,
		hasError,

		isLocalPaymentAvailable,
		onSetIsLocalPaymentAvailable,
	};
};
